import {CtPage} from './ct-page';
import {Language} from './language';
import {CtLocaleKey} from './ct-locale-key';

import {construct, createInstance, ModelProperties} from '../utils';
import { observable } from 'mobx';

export class CtLocaleContent {
    @observable id!: number;

    @observable contentEdited!: string;

    @observable contentVerified!: string;

    @observable verified!: boolean;

    @observable outdated!: boolean;

    @observable pageId!: number;

    @observable keyId!: number;

    @observable languageId!: number;

    @observable page?: CtPage;

    @observable key?: CtLocaleKey;

    @observable language?: Language;

    @observable createdAt!: Date;
    @observable updatedAt!: Date;

    constructor(content?: ModelProperties<CtLocaleContent>) {
        if (content) {
            construct(this, content);
            this.page = createInstance(CtPage, content.page);
            this.key = createInstance(CtLocaleKey, content.key);
            this.language = createInstance(Language, content.language);
        }
    }
}